var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bay-item" },
    [
      _c(
        "bay-item-name",
        _vm._g(
          {
            attrs: {
              name_object: _vm.bay_item.name_object,
              index: _vm.index,
              editable: _vm.editable
            }
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "two-column" },
        [
          _c(
            "bay-l-item",
            _vm._g(
              {
                attrs: {
                  item: _vm.bay_item.l_object,
                  event_info: _vm.event_info,
                  is_bi: _vm.is_bi,
                  name: _vm.bay_item.name_object.value,
                  index: _vm.index
                }
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "bay-r-item",
            _vm._g(
              {
                attrs: {
                  item: _vm.bay_item.r_object,
                  event_info: _vm.event_info,
                  is_bi: _vm.is_bi,
                  name: _vm.bay_item.name_object.value,
                  index: _vm.index
                }
              },
              _vm.$listeners
            )
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }